import React, { useState } from "react";
import useStyles from "../../components/Common/styles";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toastr } from "../../components/Common/toastr";
import { Blade, BladeValidationDisplay, BladeTabPanel } from "../../components/Common/Blade";
import { TextField, Tab, Tabs, Grid, Typography, Button } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { useForm } from "react-hook-form";
import useProtectApi from "../../hooks/useProtectApi";
import { useFetchRemediationStatus } from "../../hooks/useFetchEntity";
import { DeleteButton } from "../../components/Common/Buttons";

const RemediationStatusManage = () => {
	const [value, setValue] = React.useState(0);
	const [localRemediationStatus] = useFetchRemediationStatus();

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	function a11yProps(index) {
		return {
			id: `tab-${index}`,
			"aria-controls": `tabpanel-${index}`,
		};
	}
	return !localRemediationStatus ? (
		<div></div>
	) : (
		<Blade>
			<Tabs
				value={value}
				onChange={handleChange}
				aria-label="user tabs"
				variant="fullWidth"
				indicatorColor="primary">
				<Tab label="Details" {...a11yProps(0)} />
				<Tab label="Remove" {...a11yProps(1)} />
			</Tabs>
			<BladeTabPanel value={value} index={0}>
				<RemediationStatusDetails remediationStatus={localRemediationStatus} />
			</BladeTabPanel>
			<BladeTabPanel value={value} index={1}>
				<RemoveRemediationStatus remediationStatus={localRemediationStatus} />
			</BladeTabPanel>
		</Blade>
	);
};

const RemediationStatusDetails = ({ remediationStatus }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const renameRemediationStatusApi = useProtectApi("remediationStatus/rename");
	const { register, handleSubmit, errors } = useForm();
	const history = useHistory();

	const [isBusy, setIsBusy] = useState(false);
	const [apiErrors, setApiErrors] = useState();

	const onSubmit = async (data) => {
		var request = {
			id: remediationStatus.id,
			name: data.name,
		};

		const renameRemediationStatus = () =>
			renameRemediationStatusApi.api().then((w) =>
				w
					.put(request)
					.badRequest((err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.error(409, (err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.json((json) => {
						var modifiedRemediationStatus = {
							...request,
						};

						dispatch({
							type: "RENAME_REMEDIATION_STATUS",
							payload: modifiedRemediationStatus,
						});

						return modifiedRemediationStatus;
					})
					.then(() => toastr.success("Remediation Status details changed"))
					.then(() => closeDrawer())
					.catch((error) => {
						console.log(error);
						toastr.error("Unable to change Remediation Status name.");
					})
					.finally(() => setIsBusy(false))
			);

		setIsBusy(true);
		renameRemediationStatus();
	};

	const closeDrawer = () => {
		history.goBack();
	};

	return (
		<div>
			<form onSubmit={handleSubmit(onSubmit)}>
				<section>
					<TextField
						label="Name *"
						fullWidth
						autoFocus
						name="name"
						error={!!(errors && errors.name)}
						style={{ marginBottom: 16 }}
						autoComplete="off"
						inputRef={register({
							required: {
								value: true,
								message: "Name is required",
							},
							maxLength: {
								value: 255,
								message: "Name is too long",
							},
						})}
						inputProps={{
							"aria-label": "Name",
						}}
						helperText={errors && errors.name && errors.name.message}
						defaultValue={remediationStatus.name}
					/>
				</section>

				{!!apiErrors && <BladeValidationDisplay validationErrors={apiErrors} />}

				<div className={classes.drawerBladeToolbar}>
					<Button
						variant="contained"
						color="primary"
						size="medium"
						type="submit"
						className={classes.button}
						endIcon={<SaveIcon />}
						disabled={isBusy}>
						SAVE
					</Button>
				</div>
			</form>
		</div>
	);
};

const RemoveRemediationStatus = ({ remediationStatus }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const removeRemediationStatusApi = useProtectApi("remediationStatus/delete");
	const [isBusy, setIsBusy] = useState(false);
	const [apiErrors, setApiErrors] = useState();

	const closeDrawer = () => {
		history.goBack();
	};

	const removeRemediationStatusClick = () => {
		var request = {
			Id: remediationStatus.id,
		};

		const apiDelete = () =>
			removeRemediationStatusApi.api().then((w) =>
				w
					.put(request)
					.badRequest((err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.error(409, (err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.res(() => {
						dispatch({
							type: "REMOVE_REMEDIATION_STATUS",
							payload: remediationStatus,
						});
					})
					.then(() => toastr.success("Remediation Status removed"))
					.then(() => closeDrawer())
					.catch((error) => {
						console.log(error);
						toastr.error("Unable to remove Remediation Status.");
					})
			);

		setIsBusy(true);
		apiDelete();
	};

	return (
		<div>
			<Typography>
				<p>Remove Remediation Status '{remediationStatus.name}' from the application?</p>
				<p>If you do so this Remediation Status will no longer be available.</p>
			</Typography>

			<div className={classes.drawerBladeToolbar}>
				<DeleteButton
					variant="outlined"
					color="primary"
					size="medium"
					onClick={() => removeRemediationStatusClick()}
					className={classes.button}
					disabled={isBusy}
					text="Remove"
				/>
			</div>

			{!!apiErrors && <BladeValidationDisplay validationErrors={apiErrors} />}
		</div>
	);
};

export default RemediationStatusManage;
